import Evaluation from 'src/icons/untitled-ui/duocolor/document-type/evaluation-document';
import SessionNotes from 'src/icons/untitled-ui/duocolor/document-type/session-notes';
import Recertification from 'src/icons/untitled-ui/duocolor/document-type/recertification';
import Addendum from 'src/icons/untitled-ui/duocolor/document-type/andeddum-notes';
import Discharge from 'src/icons/untitled-ui/duocolor/document-type/discharge';
import ProgressNote from 'src/icons/untitled-ui/duocolor/document-type/progress-note';

type Props = {
  docType: string;
};

const documentTypeEnum = {
  weeklyProgressNotes: 'WEEKLY_PROGRESS_NOTE',
  discharge: 'DISCHARGE',
  evaluation_pt: 'EVALUATION',
  recertification: 'RECERTIFICATION',
  addendumNote: 'ADDENDUM_NOTE',
  dailyProgressNote: 'DAILY_PROGRESS_NOTE',
};

const GetDocumentIcon = (props: Props) => {
  const { docType } = props;

  return (
    <>
      {docType.includes(documentTypeEnum.evaluation_pt) ? (
        <Evaluation />
      ) : docType.includes(documentTypeEnum.weeklyProgressNotes) ||
        docType.includes(documentTypeEnum.dailyProgressNote) ? (
        <ProgressNote />
      ) : docType.includes(documentTypeEnum.addendumNote) ? (
        <Addendum />
      ) : docType.includes(documentTypeEnum.discharge) ? (
        <Discharge />
      ) : docType.includes(documentTypeEnum.recertification) ? (
        <Recertification />
      ) : null}
    </>
  );
};

export default GetDocumentIcon;
